interface Props {
  id: string;
}

export const FieldError = ({ children, id }: React.WithChildren<Props>) => {
  return (
    <div className="relative text-error-45 body-5">
      <div className="pointer-events-none -mt-[1.125rem] opacity-0" aria-hidden="true">
        {children}
      </div>
      <div id={id} aria-live="polite" className="absolute left-0 top-0">
        {children}
      </div>
    </div>
  );
};
